import React from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Divider, Tooltip } from "@mui/material";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { Container } from "@mui/material";
import { Chip } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TableContainer from "@mui/material/TableContainer";
import { ExpandMore } from "../../Functions/ScreenOperation/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { db } from "../../Environment/firebase";
import { getKeyImageUrl } from "../../Functions/APIservice/useStorage";
import { CatalogueUniversalViewerService } from "../../Modules/Viewer/CatalogueUniversalViewerService";
import { auth } from "../../Environment/firebase";
import firebase from "firebase/compat/app";
import { useAuthContext } from "../../Modules/Auth/AuthContext";
import {
  handleUsersAndDwh,
  setDatabaseData,
} from "../../Functions/APIservice/useDatabase";
import CatalogueDiagnosis from "../../Modules/Catalogue/CatalogueDiagnosis";

type CatalogueDataType = {
  title: string;
  modality: string;
  share: string;
  clinicalDiagnosis: string;
  findingsAnonymize: string;
  diagnosis: string;
  PatientInfo: string;
};

type CatalogueContentsBaseType = {
  catalogueData: firebase.firestore.DocumentData;
};

export default function CatalogueContents(props: CatalogueContentsBaseType) {
  const { uploaderId, CatalogueId } = useParams();
  const catalogueData = props.catalogueData;

  //const [catalogueData, setCatalogueData] = React.useState<firebase.firestore.DocumentData>({});
  //const [show,setShow] = React.useState(false);
  const [infoExpanded, setInfoExpanded] = React.useState(false);
  const [diagnosisExpanded, setDiagnosisExpanded] = React.useState(true);
  const [keyImageExpanded, setKeyImageExpanded] = React.useState(true);
  const [imageData, setImageData] = React.useState<string[]>([]);
  const [keyImageDataset, setKeyImageDataset] = React.useState<
    {
      path: string;
      name: number;
      studyUId: string;
      seriesUId: string;
      sopInstanceUId: string;
      description: string;
      share: boolean;
    }[]
  >([]);
  const [showImageUrl, setShowImageUrl] = React.useState<{
    url: string;
    index: number | null;
  }>({ url: "", index: null });
  const [keyImageInfo, setKeyImageInfo] = React.useState({
    seriesUId: "",
    sopInstanceUId: "",
  });
  const [handlekeyImageInfoTime, setHandlekeyImageInfoTime] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [isGood, setIsGood] = React.useState(false);
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [goodCount, setGoodCount] = React.useState(0);
  const [favoriteCount, setFavoriteCount] = React.useState(0);
  const [viewCountor, setViewCountor] = React.useState(0);
  const { userDataId } = useAuthContext();
  const titleRef = React.useRef<HTMLDivElement>(null);
  const [titleHeight, setTitleHeight] = React.useState(0);

  const handleExpandClick = (mode = "normal") => {
    if (mode === "info") {
      setInfoExpanded(!infoExpanded);
    } else if (mode === "diagnosis") {
      setDiagnosisExpanded(!diagnosisExpanded);
    } else if (mode === "keyImage") {
      setKeyImageExpanded(!keyImageExpanded);
    }
  };

  const handleOpen = (path: string, index: number) => {
    setShowImageUrl({ url: path, index: index });
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleKeyImageInfo = (idx: number) => {
    var new_value_id = keyImageDataset[idx].seriesUId;
    var new_instance_id = keyImageDataset[idx].sopInstanceUId;
    var implement_date = Date.now();

    const newKeyImageInfoValue = {
      seriesUId: new_value_id,
      sopInstanceUId: new_instance_id,
    };
    setKeyImageInfo(newKeyImageInfoValue);
    setHandlekeyImageInfoTime(implement_date);
  };

  const getKeyImageDataset = async (
    keyImages: string[],
    id: string
  ): Promise<
    {
      path: string;
      name: number;
      studyUId: string;
      seriesUId: string;
      sopInstanceUId: string;
      description: string;
      share: boolean;
    }[]
  > => {
    const ImageDatas = await Promise.all(
      keyImages.map(async (keyImage) => {
        const dataset = await db
          .collection("dwh")
          .doc(id)
          .collection("KeyImageData")
          .doc(keyImage)
          .get()
          .then((doc) => {
            return {
              path: keyImage,
              name: doc.data()?.name,
              studyUId: doc.data()?.studyUId,
              seriesUId: doc.data()?.seriesUId,
              sopInstanceUId: doc.data()?.sopInstanceUId,
              description: doc.data()?.description || "",
              share: doc.data()?.share || false,
            };
          });
        return dataset;
      })
    );
    return ImageDatas;
  };

  async function handleGood(dwhId?: string) {
    if (userDataId && dwhId)
      try {
        const NowDate = new Date();
        await handleUsersAndDwh(userDataId, dwhId, "good", isGood, {
          registrationDate: NowDate,
        }).then((res) => {
          setGoodCount((prev) => (isGood ? prev - 1 : prev + 1));
          setIsGood((prev) => !prev);
        });
        console.log("handleGood succeeded");
      } catch (error) {
        console.error("handleGood failed:", error);
      }
  }

  async function handleFavorite(dwhId?: string) {
    if (userDataId && dwhId)
      try {
        const NowDate = new Date();
        await handleUsersAndDwh(userDataId, dwhId, "favorite", isFavorite, {
          registrationDate: NowDate,
        }).then((res) => {
          setFavoriteCount((prev) => (isFavorite ? prev - 1 : prev + 1));
          setIsFavorite((prev) => !prev);
        });
        console.log("handleFavorite succeeded");
      } catch (error) {
        console.error("handleFavorite failed:", error);
      }
  }

  async function handleHistory(dwhId?: string) {
    if (userDataId && dwhId)
      try {
        const setUserViewData = {
          viewTime: new Date(),
        };
        await handleUsersAndDwh(
          userDataId,
          dwhId,
          "history",
          false,
          setUserViewData
        );
      } catch (error) {
        console.error("Error", error);
      }
  }

  React.useEffect(() => {
    if (CatalogueId) {
      db.collection("dwh")
        .doc(CatalogueId)
        .get()
        .then((dwh_doc) => {
          if (dwh_doc.exists) {
            setViewCountor(dwh_doc.data()?.viewCount || 0);
            if (userDataId) {
              db.collection("users")
                .doc(userDataId)
                .collection("history")
                .doc(CatalogueId)
                .get()
                .then((doc) => {
                  const nowDate = new Date();
                  if (doc.exists) {
                    var diff =
                      nowDate.getTime() -
                      (doc.data()?.viewTime.seconds * 1000 +
                        doc.data()?.viewTime.nanoseconds / 1000000);
                    const time = Math.abs(diff);
                    if (time > 3600000) {
                      setDatabaseData("dwh", CatalogueId, {
                        viewCount: (dwh_doc.data()?.viewCount || 0) + 1,
                      });
                    }
                    handleHistory(CatalogueId);
                  } else {
                    handleHistory(CatalogueId);
                    setDatabaseData("dwh", CatalogueId, {
                      viewCount: (dwh_doc.data()?.viewCount || 0) + 1,
                    });
                  }
                });
            }
          }
        });
    }
  }, [CatalogueId, userDataId]);

  /*
        React.useEffect(() => {
            if (userDataId) {
                db.collection("users")
                    .doc(userDataId)
                    .collection("good")
                    .doc(CatalogueId)
                    .get()
                    .then((doc) => {
                        if (doc.exists) {
                            setIsGood(true)
                        } else {
                            setIsGood(false)
                        }
                    }
                    )
            }
        },[CatalogueId])
        */

  React.useEffect(() => {
    if (userDataId && CatalogueId) {
      const docRef = db.collection("dwh").doc(CatalogueId);
      Promise.all([
        docRef.collection("favorite").doc(userDataId).get(),
        docRef.collection("good").doc(userDataId).get(),
        docRef.collection("favorite").get(),
        docRef.collection("good").get(),
      ])
        .then(([favDoc, goodDoc, favRef, goodRef]) => {
          const isFavorite = favDoc.exists;
          const isGood = goodDoc.exists;
          setIsFavorite(isFavorite);
          setIsGood(isGood);
          setGoodCount(goodRef.size);
          setFavoriteCount(favRef.size);
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    }
  }, [CatalogueId, userDataId]);

  React.useEffect(() => {
    const fetchKeyImages = async () => {
      const keyImageDatasPromises: Promise<string>[] = keyImageDataset.map(
        async (item) => {
          const urlResult = await getKeyImageUrl(
            `gs://mnes-mnist-imagestudy.appspot.com/KeyImage/${catalogueData.id}/${item.path}`
          );
          return urlResult;
        }
      );

      Promise.all(keyImageDatasPromises).then((result) => setImageData(result));

      // const keyImageDatas = await Promise.all(keyImageDatasPromises);
      // console.log(keyImageDatas);
      // setImageData(keyImageDatas);
    };

    fetchKeyImages();
  }, [catalogueData.id, keyImageDataset]);

  React.useEffect(() => {
    getKeyImageDataset(catalogueData.KeyImages, catalogueData.id).then(
      (result) => {
        let selectedKeyImageDataset = result.filter(
          (item: {
            path: string;
            name: number;
            studyUId: string;
            seriesUId: string;
            sopInstanceUId: string;
            description: string;
            share: boolean;
          }) => item.share === true
        );
        setKeyImageDataset(selectedKeyImageDataset);
      }
    );
  }, [catalogueData]);

  React.useEffect(() => {
    if (titleRef.current) {
      setTitleHeight(titleRef.current.clientHeight);
    }
  }, [catalogueData]);

  return (
    <Container sx={{ mt: 1, mb: 1, py: 2 }}>
      <Grid
        display={{ md: "grid" }}
        gridTemplateColumns={{ md: "2fr 1fr" }}
        alignItems={{ md: "start" }}
        spacing={3}
        sx={{ mt: 1 }}
      >
        <Grid item xs={12} sm={7} style={{ background: "white" }}>
          <Grid
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            display={{ md: "grid" }}
            sx={{ gap: 0 }}
          >
            <Typography
              ref={titleRef}
              variant="h5"
              component="div"
              sx={{ fontWeight: "bold", textAlign: "left", m: 0 }}
            >
              {catalogueData.title || ""}
            </Typography>
            <Divider sx={{ bgcolor: "black", mt: 0.5, mb: 1 }} />
            <Grid
              display={{ md: "flex", xs: "flex" }}
              sx={{ gap: 3 }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid display="flex" sx={{ gap: 3, alignItems: "center" }}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="div"
                  sx={{ m: 0 }}
                >
                  {catalogueData.ageSearch + "代"}
                </Typography>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="div"
                  sx={{ m: 0 }}
                >
                  {catalogueData.sex === "1"
                    ? "男性"
                    : catalogueData.sex === "2"
                    ? "女性"
                    : "不明"}
                </Typography>
              </Grid>
              <Grid
                alignItems={"center"}
                display={{ md: "flex", xs: "flex" }}
                sx={{ gap: 2 }}
                justifyContent="flex-end"
              >
                <Grid
                  display={{ md: "flex", xs: "flex" }}
                  gap={0.5}
                  sx={{ mx: 1 }}
                >
                  <VisibilityIcon />
                  <Typography>{viewCountor}</Typography>
                </Grid>
                <Button
                  onClick={() => {
                    handleGood(CatalogueId);
                  }}
                >
                  {isGood ? <ThumbUpAltIcon /> : <ThumbUpOffAltIcon />}
                  <Typography sx={{ ml: 0.5 }}>{goodCount}</Typography>
                </Button>
                {/* <Button
                  onClick={() => {
                    handleFavorite(CatalogueId);
                  }}
                >
                  {isFavorite ? (
                    <BookmarksIcon />
                  ) : (
                    <BookmarksOutlinedIcon />
                  )}
                  <Typography sx={{ ml: 0.5 }}>{favoriteCount}</Typography>
                </Button> */}
              </Grid>
            </Grid>
          </Grid>
          <CatalogueUniversalViewerService
            CatalogueId={CatalogueId || ""}
            displayAllImage={false}
            title={catalogueData.title || ""}
            age={catalogueData.ageSearch + "代"}
            sex={catalogueData.sex}
            modality={catalogueData.modality}
            keyImageInfo={keyImageInfo}
            handlekeyImageInfoTime={handlekeyImageInfoTime}
          />
          {/* KeyImages xs,sm */}
          <Grid
            item
            sx={{
              mb: 3,
              display: { xs: "block", md: "none" },
            }}
          >
            <Grid
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{
                display: "flex",
                mb: 1,
              }}
            >
              <Box display="flex" alignItems="center">
                <Typography
                  variant="h5"
                  color="text.secondary"
                  textAlign="left"
                >
                  Key Images
                </Typography>
                <ExpandMore
                  expand={keyImageExpanded}
                  onClick={() => {
                    handleExpandClick("keyImage");
                  }}
                  aria-expanded={keyImageExpanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon
                    sx={{ color: "text.secondary", fontSize: 30 }}
                  />
                </ExpandMore>
              </Box>
            </Grid>
            <Collapse
              in={keyImageExpanded}
              timeout="auto"
              unmountOnExit
              sx={{
                maxWidth: "100vw",
                overflow: "auto",
                whiteSpace: "nowrap",
                "&::-webkit-scrollbar": {
                  height: 8,
                  width: 8,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#bbb",
                  borderRadius: 5,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#eee",
                  borderRadius: 5,
                },
              }}
            >
              <Box sx={{ display: "flex" }}>
                {imageData.map((image: string, idx: number) => (
                  <Box
                    key={image}
                    sx={{
                      display: "inline-flex",
                      flexDirection: "column",
                      alignItems: "center",
                      mr: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 140,
                        minHeight: 25,
                        p: 0,
                        borderRadius: 0,
                        bgcolor: "#EFF2F5",
                        position: "relative",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: 25,
                          height: 25,
                          bgcolor: "#D7DFE6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography>{keyImageDataset[idx].name}</Typography>
                      </Box>
                      <Tooltip
                        title="Viewerに表示"
                        placement="bottom"
                        PopperProps={{
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -5],
                              },
                            },
                          ],
                        }}
                      >
                        <Button
                          onClick={() => {
                            handleKeyImageInfo(idx);
                          }}
                          sx={{
                            height: 25,
                            width: 140,
                            p: 0,
                            borderRadius: 0,
                            color: "#424242",
                          }}
                        >
                          <KeyboardDoubleArrowLeftIcon
                            sx={{ fontSize: 20, transform: "rotate(90deg)" }}
                          />
                        </Button>
                      </Tooltip>
                    </Box>
                    <CardMedia
                      sx={{
                        height: 140,
                        width: 140,
                        objectFit: "cover",
                        "&:hover": { cursor: "pointer" },
                      }}
                      component="img"
                      image={image}
                      onClick={() => handleOpen(image, idx)}
                    />
                  </Box>
                ))}
              </Box>
            </Collapse>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-left"
            alignItems="center"
            sx={{ display: "flex" }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="h5" color="text.secondary" textAlign="left">
                Diagnosis
              </Typography>
              <ExpandMore
                expand={diagnosisExpanded}
                onClick={() => {
                  handleExpandClick("diagnosis");
                }}
                aria-expanded={diagnosisExpanded}
                aria-label="show more"
              >
                <ExpandMoreIcon
                  sx={{ color: "text.secondary", fontSize: 30 }}
                />
              </ExpandMore>
            </Box>
          </Grid>
          <Collapse in={diagnosisExpanded} timeout="auto" unmountOnExit>
            <CatalogueDiagnosis
              title="経過"
              content={catalogueData.clinicalDiagnosisAnonymize}
            />
            <CatalogueDiagnosis
              title="所見"
              content={catalogueData.findingsAnonymize}
            />
            <CatalogueDiagnosis
              title="診断"
              content={catalogueData.diagnosisAnonymize}
            />
          </Collapse>
        </Grid>
        {/* KeyImages md,lg */}
        <Grid
          item
          xs={12}
          sm={5}
          sx={{
            ml: { base: 0, md: 3.5 },
            display: { xs: "none", md: "block" },
          }}
        >
          <Grid
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{
              display: "flex",
              mb: 1,
              mt: { base: 0, md: `${titleHeight + 64}px` },
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="h5" color="text.secondary" textAlign="left">
                Key Images
              </Typography>
              <ExpandMore
                expand={keyImageExpanded}
                onClick={() => {
                  handleExpandClick("keyImage");
                }}
                aria-expanded={keyImageExpanded}
                aria-label="show more"
              >
                <ExpandMoreIcon
                  sx={{ color: "text.secondary", fontSize: 30 }}
                />
              </ExpandMore>
            </Box>
          </Grid>
          <Collapse
            in={keyImageExpanded}
            timeout="auto"
            unmountOnExit
            sx={{
              maxWidth: { xs: "90vw", md: "30vw" },
              maxHeight: { base: "none", md: "60vh" },
              overflow: "auto",
              "&::-webkit-scrollbar": {
                height: 8,
                width: 8,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#bbb",
                borderRadius: 5,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#eee",
                borderRadius: 5,
              },
            }}
          >
            <Grid container spacing={2}>
              {imageData.map((image: string, idx: number) => (
                <Grid item xs={12} sm={4} md={12} lg={6} key={image}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          minHeight: 140,
                          minWidth: 25,
                          p: 0,
                          borderRadius: 0,
                          bgcolor: "#EFF2F5",
                          position: "relative",
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            width: 25,
                            height: 25,
                            bgcolor: "#D7DFE6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography>{keyImageDataset[idx].name}</Typography>
                        </Box>
                        <Tooltip
                          title="Viewerに表示"
                          placement="left"
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -5],
                                },
                              },
                            ],
                          }}
                        >
                          <Button
                            onClick={() => {
                              handleKeyImageInfo(idx);
                            }}
                            sx={{
                              minWidth: 25,
                              height: 140,
                              p: 0,
                              borderRadius: 0,
                              color: "#424242",
                            }}
                          >
                            <KeyboardDoubleArrowLeftIcon
                              sx={{ fontSize: 20 }}
                            />
                          </Button>
                        </Tooltip>
                      </Box>
                      <CardMedia
                        sx={{
                          height: 140,
                          width: 140,
                          objectFit: "cover",
                          "&:hover": { cursor: "pointer" },
                        }}
                        component="img"
                        image={image}
                        onClick={() => handleOpen(image, idx)}
                      />
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Collapse>
        </Grid>
        <Dialog open={open} onClose={handleClose} maxWidth="md">
          <DialogContent>
            <Card sx={{ display: "flex" }}>
              <CardMedia
                component="img"
                sx={{ height: 400, width: "auto", objectFit: "contain" }}
                image={showImageUrl.url}
                alt="KeyImage"
              />
            </Card>
          </DialogContent>
        </Dialog>
      </Grid>
    </Container>
  );
}
